import { Variant } from "@/helper/chart/types/chart.type";

export const colorByVariant: Record<Variant, string> = {
  primary: "#F3F3F4",
  secondary: "#25292D",
};

export const barChartColors = ["#1E5F6F", "#64C7D2"];

export const barColors = {
  cyan700: "#1E5F6F",
  cyan500: "#4BD5BA",
  cyan400: "#00D2CD",
  cyan300: "#36AAC6",
  slate100: "#F0F3FF",
  rose700: "#5C0021",
  rose500: "#B70141",
  rose400: "#F40157",
  rose300: "#FE2572",
  darkBlue: "#024677",
  charcoalGray: "#25292D",
};
